<div class="flex items-center gap-3" [ngClass]="className" [class.flex-row-reverse]="labelPosition === 'before'">
    <!-- Toggle Button -->
    <button type="button" (click)="handleToggle()" [disabled]="disabled"
        class="relative rounded-full transition-all duration-300 focus:outline-none" [ngClass]="{
      'bg-gradient-to-r from-purple-600 to-indigo-600': isChecked(),
      'bg-slate-300 dark:bg-slate-700': !isChecked(),
      'opacity-50 cursor-not-allowed': disabled,
      'cursor-pointer': !disabled,
      'w-9 h-5': size === 'sm',
      'w-11 h-6': size === 'md',
      'w-14 h-8': size === 'lg'
    }">
        <span class="absolute top-1 left-1 bg-white dark:text-black rounded-full transition-all duration-300 shadow-sm" [ngClass]="{
        'w-3 h-3': size === 'sm',
        'w-4 h-4': size === 'md',
        'w-6 h-6': size === 'lg',
        'translate-x-4': isChecked() && size === 'sm',
        'translate-x-5': isChecked() && size === 'md',
        'translate-x-6': isChecked() && size === 'lg',
        'translate-x-0': !isChecked()
      }">
            @if (useIcons) {
            @if (isChecked()) {
            <app-icon [name]="onIcon" [size]="iconSize"
                class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></app-icon>
            } @else {
            <app-icon [name]="offIcon" [size]="iconSize"
                class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></app-icon>
            }
            }
        </span>
    </button>

    @if (label) {
    <span class="text-slate-700 dark:text-slate-300 select-none">
        {{ label }}
    </span>
    }
</div>